import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "aiSubchapterContainer"
};
const _hoisted_2 = {
  class: "popoverPanel"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "autoTranscriptStatus"
};
const _hoisted_6 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_loader = _resolveComponent("loader");
  const _component_w_tool_tip = _resolveComponent("w-tool-tip");
  const _component_icon = _resolveComponent("icon");
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dropdown, {
    trigger: 'click',
    disabled: _ctx.disabled,
    teleported: false
  }, {
    dropdown: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_checkbox_group, {
      modelValue: _ctx.subchapterSelected,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.subchapterSelected = $event)
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.speach.chapters, chapter => {
        return _openBlock(), _createElementBlock("div", {
          class: "chapterLine",
          key: 'chapterSelector' + chapter.id
        }, [_createElementVNode("div", {
          class: "chapterTitle",
          onClick: $event => _ctx.onSelectAllChapter(chapter.id)
        }, _toDisplayString(chapter.number) + " - " + _toDisplayString(chapter.title), 9, _hoisted_3), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chapter.subchapters, subChapter => {
          return _openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["subChapterLine", {
              disabled: !_ctx.isSubChapterSelectable(subChapter.id)
            }]),
            key: 'subchapterSelector' + subChapter.id,
            onClick: _withModifiers($event => _ctx.onSubChapterSelected(subChapter.id), ["stop"])
          }, [_createVNode(_component_el_checkbox, {
            value: subChapter.id,
            disabled: !_ctx.isSubChapterSelectable(subChapter.id),
            onChange: $event => _ctx.onSubChapterSelected(subChapter.id),
            class: "subChapterCheckBox"
          }, null, 8, ["value", "disabled", "onChange"]), _createElementVNode("div", {
            class: _normalizeClass(["subChapterTitle", {
              disabled: !_ctx.isSubChapterSelectable(subChapter.id)
            }])
          }, _toDisplayString(chapter.number) + "-" + _toDisplayString(subChapter.number) + " " + _toDisplayString(subChapter.title), 3), _createElementVNode("div", _hoisted_5, [_ctx.getAutoTranscriptStatus(subChapter.id) === 'WAITING' ? (_openBlock(), _createBlock(_component_w_tool_tip, {
            key: 0,
            text: _ctx.$t('aiQuizGeneration.selectAIChapters.proccessInProgress')
          }, {
            default: _withCtx(() => [_createVNode(_component_loader, {
              "spinner-size": 'small'
            })]),
            _: 1
          }, 8, ["text"])) : _createCommentVNode("", true), _ctx.getAutoTranscriptStatus(subChapter.id) === 'NONE' || _ctx.getAutoTranscriptStatus(subChapter.id) === 'ERROR' ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "buttonRestartAutoTranscript",
            onClick: $event => _ctx.forceRegenerateTranscript(subChapter.id)
          }, [_createVNode(_component_w_tool_tip, {
            text: _ctx.$t('aiQuizGeneration.selectAIChapters.launchTranscript')
          }, {
            default: _withCtx(() => [_createVNode(_component_icon, {
              icon: "restart"
            })]),
            _: 1
          }, 8, ["text"])], 8, _hoisted_6)) : _createCommentVNode("", true)])], 10, _hoisted_4);
        }), 128))]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue"])])]),
    default: _withCtx(() => [_createElementVNode("span", {
      class: _normalizeClass(["selectChapter", {
        disabled: _ctx.disabled
      }])
    }, _toDisplayString(_ctx.$t('aiQuizGeneration.selectAIChapters.chapterSelected', {
      nb: this.subchapterSelected.length
    })), 3)]),
    _: 1
  }, 8, ["disabled"])]);
}